import React, { Component } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { CtrlCollection } from "@yuigoto/ctrl";

import { MagicaCookieControls } from "controls/MagicaCookieControls";
import { UiActions } from "state/actions/UiActions";
import { TokenActions } from "state/actions/user/TokenActions";
import { ControlRenderer } from "components/renderers/ControlRenderer";

class CookieMagic extends Component {
  constructor (props) {
    super(props);

    this.collection = new CtrlCollection();

    for (let control of MagicaCookieControls) {
      this.collection.add(control);
    }

    this.executeLogin = this.executeLogin.bind(this);
    this.executeLogout = this.executeLogout.bind(this);
    this.renderForm = this.renderForm.bind(this);
    this.renderSubmit = this.renderSubmit.bind(this);
  }

  componentDidMount () {
    const {
      history,
      person
    } = this.props;
    if (person.person.username !== "tecnologia@b4agroup.com" &&
      person.person.username !== "suporte@weclever.co") {
      history.push("/");
    }
  }

  executeLogin (event) {
    event.preventDefault();

    let cookieData = this.collection.toObject();
    
    if (!this.collection.validate()) {
      this.forceUpdate();
      return;
    }

    this.props.doLogin(     
      cookieData.email,
      this.onSuccess
    );
  }

  onSuccess = () => {
    const {
      history
    } = this.props;

    if (history) {
      history.push("/");
    }
  };

  executeLogout () {
    this.props.doLogout();
  }

  renderSubmit () {
    const { props } = this;
    const { token } = props;

    if (token.pending) {
      return (
        <button type={"button"} className={"btn btn-light-gray btn-block"}>
          Carregando... <span>😒</span>
        </button>
      );
    }

    return (
      <button type={"submit"} className={"btn btn-light-lime btn-block"}>
        Login <span>😲</span>
      </button>
    );
  }

  renderForm () {
    return (
      <div className={"p-2 p-lg-5"}>   
        <Helmet>
          <title>Minha Glambox : Mágica do Cookie</title>
        </Helmet>
      
        <h1>Mágica do <span>🍪</span></h1>

        <div className={"p-2 p-lg-5 text-center"}>
          <p className={"lead text-muted"}>Coloque um endereço de e-mail para personificar o usuário! <span>😉</span></p>
        
          <form onSubmit={this.executeLogin}>
            {ControlRenderer.renderCollection(this.collection)}
            <br/>
            {this.renderSubmit()}
          </form>
        </div>
      </div>
    );
  }

  render () {
    return this.renderForm();
  }
}

const mapStateToProps = (state) => ({
  ui: state.ui,
  token: state.token,
  person: state.person.data
});

const mapDispatchToProps = (dispatch) => ({
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
  doLogin: (email, cb) => {
    dispatch(TokenActions.cookieMagic(email, cb));
  },
  doLogout: () => {
    dispatch(TokenActions.logout());
  }
});

CookieMagic = connect(
  mapStateToProps,
  mapDispatchToProps
)(CookieMagic);

export {
  CookieMagic
};
